import { useTranslation } from "react-i18next";
import { useAuthContext } from "../providers/AuthProvider";
import { ClipLoader } from "react-spinners";

type PropsType = {
    headings: Heading[];
    data: Row[];
    settings: TableSettings;
    renderActions?: (id: number) => React.ReactNode;
    loading?: boolean;
}

type Heading = {
    title: string;
}

type Row = {
    id: number;
    items: string[];
}

type TableSettings = {
    hover: boolean;
    showSettings: boolean;
}

const Table = (props: PropsType) => {
    const { headings, data, settings, renderActions, loading } = props;

    return (
        <div className="position-relative">
            {loading && (
                <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', zIndex: 1 }}>
                    <ClipLoader
                        color="var(--bs-primary)"
                        loading={true}
                        size={60}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            )}
            <table className={`table ${settings.hover ? 'table-hover' : ''}`}>
                <thead>
                    <tr>
                        {headings?.map((heading, index) => (
                            <TableHeading key={index} {...heading} />
                        ))}
                        {settings.showSettings && <th scope="col"></th>}
                    </tr>
                </thead>

                <tbody>
                    {data?.map((item, index) => (
                        <TableRow
                            key={index}
                            {...item}
                            settings={settings}
                            renderActions={renderActions}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    )
}

const TableHeading = (props: Heading) => {
    const { title } = props;

    return (
        <th scope="col">{title}</th>
    )
}

const TableRow = ({ items, settings, id, renderActions }: Row & { settings: TableSettings, id: number, renderActions?: (id: number) => React.ReactNode }) => {
    const { t } = useTranslation();
    const { user } = useAuthContext();

    return (
        <tr>
            {items.map((item) => {
                return <td key={item}>{t(item)}</td>;
            })}
            {settings.showSettings && user?.id !== id ? (
                <td>
                    {renderActions ? renderActions(id) : null}
                </td>
            ) : (
                <td></td>
            )}
        </tr>
    );
};

export default Table;